import { makeAutoObservable } from 'mobx';
import { authorizationStore } from '../../modules/authorization/authorization.store';
import { sectionTypes } from '../../modules/authorization/authorization.type';
import { apiServiceV2 } from '../../services/apiService';
import { PartnersType } from './dashboard.type';

class Dashboard {
  authPopupActive = false;

  disableHeader = false;

  navbarState = false;

  authPopupType = '';

  partners = [] as PartnersType[];

  constructor() {
    makeAutoObservable(this);
  }

  setDisableHeader = (state: boolean) => {
    this.disableHeader = state;
  };

  setNavbarState = (state: boolean) => {
    this.navbarState = state;
  };

  setPartners = (data: PartnersType[]) => {
    this.partners = data;
  };

  setAuthPopupActive = (status: boolean) => {
    this.authPopupActive = status;
  };

  setAuthPopupType = (type: sectionTypes) => {
    this.authPopupType = type;
    authorizationStore.setSectionContent(type);
  };

  getPartners = async () => {
    if (!this.partners.length) {
      try {
        const res = await apiServiceV2.getDashboardPartners();
        this.setPartners(res.data.items);
      } catch (error) {
        this.partners = [];
      }
    }
  };
}

export const dashboardStore: Dashboard = new Dashboard();
